import { useQuery } from '@tanstack/react-query';
import { TrendingDown } from 'lucide-react';
import { apiClient } from '@/lib/api-client';
import { CardShell } from '../cards/card-shell';
import { formatBrl } from './format';

/**
 * KPI: despesa prevista do mes corrente + comparativo com a realizada.
 */
export function SummaryDespesaPrevistaWidget() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['financial', 'stats', 'summary'],
    queryFn: () => apiClient.financialStatsSummary(),
    staleTime: 1000 * 60,
  });

  const prevista = data?.despesaMensalPrevista ?? 0;
  const realizada = data?.despesaMensalRealizada ?? 0;

  return (
    <CardShell title="Despesa prevista" icon={TrendingDown}>
      <div className="flex w-full flex-col items-start gap-2">
        {isLoading ? (
          <div className="flex w-full flex-col gap-2">
            <div className="h-10 w-32 animate-pulse rounded bg-[var(--surface-muted)]" />
            <div className="h-3 w-24 animate-pulse rounded bg-[var(--surface-muted)]" />
          </div>
        ) : isError ? (
          <p className="text-xs text-[var(--fg-muted)]">
            Não foi possível carregar.
          </p>
        ) : (
          <>
            <span className="text-3xl font-semibold tracking-tight tabular-nums text-red-500">
              {formatBrl(prevista)}
            </span>
            <p className="text-[11px] text-[var(--fg-muted)]">
              Realizada:{' '}
              <span className="font-medium text-[var(--fg)]">
                {formatBrl(realizada)}
              </span>
            </p>
          </>
        )}
      </div>
    </CardShell>
  );
}
